import { collectAllMeasures, getMutableComponentProps, removeMeasures } from "./utils";
import { CustomVisitorEnum } from "hooks/widget-data/datapoints-api/visitors/custom/customVisitors";
const findHistoricalMeasuresToRemove = (componentProps) => {
    const measuresToRemove = [];
    const allMeasures = collectAllMeasures(componentProps);
    allMeasures.forEach((measure) => {
        const context = measure.context;
        if (context?.historicalOnly === true && measure.name) {
            measuresToRemove.push(measure.name);
        }
    });
    return measuresToRemove;
};
const removeHistoricalMeasuresFromCompositeBuilder = (componentProps, measuresToRemove) => {
    const compositeObjectBuilder = componentProps.pipelineParameter?.compositeObjectBuilder;
    if (compositeObjectBuilder?.measures) {
        compositeObjectBuilder.measures = compositeObjectBuilder.measures.filter((measureName) => !measuresToRemove.includes(measureName));
    }
};
const removeHistoricalMeasuresFromFlattenVisitor = (componentProps, measuresToRemove) => {
    const nodesVisitors = componentProps.pipelineParameter?.nodesVisitorsReducer;
    if (nodesVisitors) {
        const flattenVisitor = nodesVisitors.find((v) => v.method === "flattenFieldsVisitor");
        if (flattenVisitor?.arguments) {
            flattenVisitor.arguments = flattenVisitor.arguments.filter((fieldName) => !measuresToRemove.includes(fieldName));
        }
    }
};
const filterHistoricalSeriesFromVisitors = (customVisitors) => {
    if (!customVisitors) {
        return;
    }
    const highchartsVisitor = customVisitors.find((v) => v.method === CustomVisitorEnum.highchartsTimeSeriesCreation);
    if (highchartsVisitor?.arguments?.series) {
        highchartsVisitor.arguments.series = highchartsVisitor.arguments.series.filter((series) => {
            const context = series.context;
            return context?.historicalOnly !== true;
        });
    }
};
export const filterCffHistoricalMeasures = (componentProps, allDependencies, originalComponentProps) => {
    if (allDependencies.includeHistoricalCashflows) {
        return componentProps;
    }
    const mutableComponentProps = getMutableComponentProps(componentProps, originalComponentProps);
    const measuresToRemove = findHistoricalMeasuresToRemove(mutableComponentProps);
    removeMeasures(mutableComponentProps, (measure) => {
        const context = measure.context;
        return context?.historicalOnly === true;
    });
    removeHistoricalMeasuresFromCompositeBuilder(mutableComponentProps, measuresToRemove);
    removeHistoricalMeasuresFromFlattenVisitor(mutableComponentProps, measuresToRemove);
    return mutableComponentProps;
};
export const filterCffHistoricalLabels = (componentProps, allDependencies, originalComponentProps) => {
    if (allDependencies.includeHistoricalCashflows) {
        return componentProps;
    }
    const mutableComponentProps = getMutableComponentProps(componentProps, originalComponentProps);
    filterHistoricalSeriesFromVisitors(mutableComponentProps.pipelineParameter?.customVisitorsReducer);
    mutableComponentProps.dataSelectProps?.forEach((selectProp) => {
        Object.values(selectProp?.selectValues ?? {}).forEach((selectValue) => {
            filterHistoricalSeriesFromVisitors(selectValue?.pipelineParameter?.customVisitorsReducer);
        });
    });
    return mutableComponentProps;
};
